import { GoogleOAuthProvider } from '@react-oauth/google'
import config from './lib/config'
import { RouterProvider } from "react-router-dom";
import { MarketplaceExperimentProvider, UserContextProvider } from './contexts'
import ExperimentDebugTool from './components/ExperimentDebugTool/ExperimentDebugTool';

const Providers = ({router, children }) => {
  if (!router){
    return (
      <UserContextProvider>
        <MarketplaceExperimentProvider>
          <ExperimentDebugTool />
          {children}
        </MarketplaceExperimentProvider>
      </UserContextProvider>
    )
  }
  return (
    <UserContextProvider>
      <MarketplaceExperimentProvider>
        <ExperimentDebugTool />
        <GoogleOAuthProvider clientId={config.googleClientId}>
            <RouterProvider router={router}>
              {children}
            </RouterProvider>
        </GoogleOAuthProvider>
      </MarketplaceExperimentProvider>
    </UserContextProvider>
  )
}

export default Providers
